import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { PermissionGuard } from './core/guard/permission.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('./views/pages/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./views/pages/products/products.module').then(
            (m) => m.ProductsModule
          ),
      },
      {
        path: 'contacts',
        //canActivate: [PermissionGuard],
        loadChildren: () =>
          import('./views/pages/contacts/contacts.module').then(
            (m) => m.ContactsModule
          ),
      },
      {
        path: 'purchase-order',

        loadChildren: () =>
          import(
            './views/pages/orders/purchase-order/purchase-order.module'
          ).then((m) => m.PurchaseOrderModule),
      },
      {
        path: 'sale-order',

        loadChildren: () =>
          import('./views/pages/orders/sale-order/sale-order.module').then(
            (m) => m.SaleOrderModule
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./views/pages/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
      },
      {
        path: 'smart-cart',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('./views/pages/smart-cart/smart-cart.module').then(
            (m) => m.SmartCartModule
          ),
      },
      {
        path: 'inventory',

        loadChildren: () =>
          import('./views/pages/inventory/inventory.module').then(
            (m) => m.InventoryModule
          ),
      },
      {
        path: 'planning',
        loadChildren: () =>
          import('./views/pages/planning/planning.module').then(
            (m) => m.PlanningModule
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./views/pages/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import(
            './views/pages/all-notifications/all-notifications.module'
          ).then((m) => m.AllNotificationsModule),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      type: 404,
      title: 'Page Not Found',
      desc: "Oopps!! The page you were looking for doesn't exist.",
    },
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent,
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
